import $ from 'jquery';
import './sp.list-to-select';

const projectsFilter = () => {
    const $container = $('.js-projects-filters');
    const $selected = $('.is-active a', $container);

    function init () {
        const $selects = $container.spListToSelect({
            classes: 'c-filters__list--mobile'
        });
        $selects.val($selected.attr('href'));
        $selects.on('change', function () {
            window.location = $(this).val();
        });
    }

    return {
        init: init
    }
};

export default projectsFilter;
